import { MEMBER_TAB_VIEW_PERMISSIONS } from '@bo-constants/permissions';
import { createSelector } from '@reduxjs/toolkit';
import { selectUserRoles } from '@bo-services/authenticationSlice';

const {
  MEMBER_VIEW_ENTRIES,
  MEMBER_VIEW_NOTES,
  MEMBER_VIEW_PAYMENTS,
  MEMBER_VIEW_PROMOTIONS,
  MEMBER_VIEW_RG,
  MEMBER_VIEW_TRANSACTIONS
} = MEMBER_TAB_VIEW_PERMISSIONS;

export const selectMemberTabsAccessPermisions = createSelector(
  [selectUserRoles],
  (roles) => {
    const hasViewMemberEntriesAccess = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_VIEW_ENTRIES
      )
    );

    const hasViewMemberNotesAccess = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_VIEW_NOTES
      )
    );
    const hasViewMemberPaymentsAccess = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_VIEW_PAYMENTS
      )
    );
    const hasViewMemberPromotionsAccess = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_VIEW_PROMOTIONS
      )
    );

    const hasViewMemberRGAccess = roles.some((role) =>
      role.permissions.some((permission) => permission.name === MEMBER_VIEW_RG)
    );

    const hasViewMemberTransactionsAccess = roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === MEMBER_VIEW_TRANSACTIONS
      )
    );

    return {
      hasViewMemberEntriesAccess,
      hasViewMemberNotesAccess,
      hasViewMemberPaymentsAccess,
      hasViewMemberPromotionsAccess,
      hasViewMemberRGAccess,
      hasViewMemberTransactionsAccess
    };
  }
);
